import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, TextField, CircularProgress, Typography, Grid } from '@material-ui/core';
import LoginApis from "../services/LoginService";
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';

const ResetPasswordDialogBox = ({dialogOpen, closeDialog, isForceResetPw}) => {
  const [dialogStep, setDialogStep] = useState(1);
  const [dialogInfo, setDialogInfo] = useState({ username: '', oldPassword:'', token: '', newPassword: '' });
  const [loading, setLoading] = useState(false); // State to track loading
  const LoginApi = new LoginApis();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDialogInfo({ ...dialogInfo, [name]: value });
  };

  const handleEmailSubmit = async () => {
    // Simulate checking if user exists and password reset status
    
    let userName = {username:dialogInfo.username}
    LoginApi.sendPasswordResetCode(userName).then((response) => {
    })
    const user = true;
    setLoading(true); // Start loading
    alert('User found! Token sent to email');
    setLoading(false); // Stop loading
    if (user) {
      setDialogStep(2);
    } else {
      alert('User does not exist');
    }
  };

  const handleCodeSubmit = () => {
    setLoading(true); // Start loading
    let userNameTokenNewPassword = {username:dialogInfo.username,token:dialogInfo.token, newPassword:dialogInfo.newPassword}

    LoginApi.passwordResetWToken(userNameTokenNewPassword).then((response) => {

      if (response.status === 400) {
        setLoading(false);
        alert('Invalid Inputs. Please verify and try again.');
      } else {
        setLoading(false);
        alert('Password code verification Successful!');
        setLoading(false);
        handleDialogClose();
      }
    }).catch((error) => {
      setLoading(false);
      alert('Invalid code. Please check the code and try again.');
    })

  };

  const handleDialogClose = () => {
    setDialogStep(1);
    setDialogInfo({ username: '', oldPassword:'', token: '', newPassword: '' });
    closeDialog();
  };

  
  return (
        <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Reset Password</DialogTitle>
          <DialogContent>
            {dialogStep === 1 && (
              <> 
                {isForceResetPw ?
                (
                  <Grid container>
                    <Grid item sm={1}>
                      <AssignmentLateIcon style={{ fontSize: 33, verticalAlign: 'bottom', color: 'orange' }}></AssignmentLateIcon>
                    </Grid>
                    <Grid item sm={9}>
                    <Typography variant="body2" style={{ fontSize: 11, paddingBottom: 10, color: 'orange' }}>
                    Since its your first time to login with new authentication for EMTRack, we would like you to please proceed in creating a new password.
                  </Typography>
                    </Grid>
                  </Grid>
                )
                : null }
                <DialogContentText>
                  For security purposes, Please input again your username and password to proceed.:
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  name="username"
                  label="Username"
                  type="username"
                  fullWidth
                  value={dialogInfo.username}
                  onChange={handleInputChange}
                  variant="outlined"
                />
                <TextField
                  autoFocus
                  margin="dense"
                  name="oldPassword"
                  label="Password (optional)"
                  type="oldPassword"
                  fullWidth
                  value={dialogInfo.oldPassword}
                  onChange={handleInputChange}
                  variant="outlined"
                />
              </>
            )}
            {dialogStep === 2 && (
              <>
                <DialogContentText>
                  A unique token has been sent to your email. Please enter the token below:
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  name="token"
                  label="token code"
                  type="text"
                  fullWidth
                  value={dialogInfo.token}
                  onChange={handleInputChange}
                  variant="outlined"
                />
                <DialogContentText>
                  Password must at least 6 characters consist of alphanumeric with an uppercase, lowercase and special character.
                </DialogContentText>
                 <TextField
                  autoFocus
                  margin="dense"
                  name="newPassword"
                  label="New Password"
                  type="password"
                  fullWidth
                  value={dialogInfo.newPassword}
                  onChange={handleInputChange}
                  variant="outlined"
                />
              </>
            )}
          </DialogContent>
          {loading ? <CircularProgress size={24} color="inherit" /> : 
              <DialogActions>
              <Button onClick={handleDialogClose} color="primary">
                Cancel
              </Button>
              {dialogStep === 1 && (
                <Button onClick={handleEmailSubmit} color="primary">
                  Submit
                </Button>
              )}
              {dialogStep === 2 && (
                <Button onClick={handleCodeSubmit} color="primary">
                  Reset Password
                </Button>
              )}
            </DialogActions>
        }
          
        </Dialog>
  );
};

export default ResetPasswordDialogBox;